import React from "react";

export const TIME_SLOTS = [
  { value:"09:00-11:00", label:"9:00 – 11:00 AM",    period:"Morning",        icon:"🌅" },
  { value:"11:00-13:00", label:"11:00 AM – 1:00 PM",  period:"Late Morning",   icon:"☀️" },
  { value:"13:00-15:00", label:"1:00 – 3:00 PM",      period:"Afternoon",      icon:"🌤" },
  { value:"15:00-17:00", label:"3:00 – 5:00 PM",      period:"Late Afternoon", icon:"⛅" },
  { value:"17:00-19:00", label:"5:00 – 7:00 PM",      period:"Evening",        icon:"🌆" },
  { value:"19:00-21:00", label:"7:00 – 9:00 PM",      period:"Night",          icon:"🌙" },
];

interface Props { selected: string; onChange: (v: string) => void; error?: string; }

export function TimeSlotPicker({ selected, onChange, error }: Props) {
  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(180px,1fr))", gap:9 }}>
        {TIME_SLOTS.map(slot => {
          const active = selected === slot.value;
          return (
            <button key={slot.value} type="button" onClick={() => onChange(slot.value)}
              style={{ display:"flex", alignItems:"center", gap:10, padding:"12px 13px", borderRadius:11, cursor:"pointer", textAlign:"left", width:"100%", border:active?"2px solid var(--indigo)":"1.5px solid var(--border)", background:active?"var(--indigo-light)":"var(--bg)", transition:"all 0.18s", boxShadow:active?"0 0 0 3px rgba(79,70,229,0.1)":"none" }}
              onMouseEnter={e => { if (!active) (e.currentTarget as HTMLElement).style.borderColor = "var(--border-bright)"; }}
              onMouseLeave={e => { if (!active) (e.currentTarget as HTMLElement).style.borderColor = "var(--border)"; }}>
              <span style={{ fontSize:18, flexShrink:0 }}>{slot.icon}</span>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:10, fontWeight:700, color:active?"var(--indigo)":"var(--text3)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:1 }}>{slot.period}</div>
                <div style={{ fontSize:13, fontWeight:600, color:active?"var(--indigo)":"var(--text)" }}>{slot.label}</div>
              </div>
              {active && <span style={{ color:"var(--indigo)", fontWeight:800, fontSize:14, flexShrink:0 }}>✓</span>}
            </button>
          );
        })}
      </div>
      {error && <p style={{ fontSize:12, color:"var(--danger)", marginTop:10 }}>⚠ {error}</p>}
    </div>
  );
}
